import BottomCallToAction from './BottomCallToAction'

export default BottomCallToAction
